import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import styles from './News.scss'
import { NEWS_USERID } from '../App'
import { newsMessages } from '../intlMessages'
import { HeaderImg } from '../shared/HeaderImg'
import { rideReportActions, rideReportSelectors } from 'data/resources/rideReports'
import { StandardLayout } from 'common/layouts/StandardLayout'
import { ColWrap, MainCol, SecondaryCol } from 'common/layouts/SideNavLayout/TwoCol'
import { Card } from 'common/styleguide/Card'
import { CTA } from 'common/styleguide/CTA'
import { Loadable } from 'common/Loadable'
import { Icon } from 'common/Icon'
import { Msg, featureNames } from 'lib/localization'
import { FormattedMessage as T, injectIntl } from 'react-intl'
import Helmet from 'react-helmet'
import moment from 'moment'
import cx from 'classnames'

import header from './images/news-header.jpg'
import header2x from './images/news-header@2x.jpg'
import header3x from './images/news-header@3x.jpg'

import fb from 'assets/images/social/fb-icon.png'
import insta from 'assets/images/social/instagram-icon.png'
import twit from 'assets/images/social/twitter-icon.png'
import yt from 'assets/images/social/youtube-icon.png'

export class _News extends React.PureComponent {
  render () {
    const { articles } = this.props

    return (
      <StandardLayout greyBg>
        <T {...featureNames.newsAndPress}>
          {title => <Helmet title={`${title} · Ride with GPS`} />}
        </T>
        <HeaderImg
          headingAlt={<Msg m={featureNames.newsAndPress} />}
          src={header}
          srcSet={`${header} 1x, ${header2x} 2x, ${header3x} 3x`} />
        <ColWrap>
          <MainCol>
            <Card className={styles.articles}>
              {articles.valueSeq().sortBy(a => -moment(a.publishedAt).format('x')).map(a => a.authorUrl
                ? <NewsLink key={a.id} a={a} />
                : <NewsArticle key={a.id} a={a} />)}
            </Card>
          </MainCol>

          <SecondaryCol>
            <h1 data-heading-alt><Msg m={newsMessages.keepInTouch} /></h1>
            <Card className={styles.contactUs}>
              <T id='newsMessages.getInTouch'
                defaultMessage='Get in touch if you have any questions about Ride with GPS.' />
              <CTA href='mailto:kevin@ridewithgps.com?subject=Hello!' className={styles.contactUsTop}><Msg m={newsMessages.contactUs} /></CTA>
              {/* <CTA secondary className={styles.contactUsMiddle}>subscrib(ed) to news and press</CTA> */}
              <CTA target='_blank' href='https://drive.google.com/file/d/0B_91VhuaKVIMZHpLcEZCVTlTNlE/view?usp=sharing' margins={false} link className={styles.contactUsBottom}><Msg m={newsMessages.mediaKit} /></CTA>
            </Card>
            <h1 data-heading-alt><T id='newsMessages.whoWeAre' defaultMessage='Who we are' /></h1>
            <Card>
              <p><T id='newsMessages.launched'
                defaultMessage='We launched Ride with GPS in 2007, over 10 years ago! We  create route planning and navigation tools across our website and app, enabling cyclists to go on better rides more often.' /></p>

              <T id='newsMessages.headquartered'
                defaultMessage='Ride with GPS is headquartered in Portland, OR.' />
            </Card>

            <h1 data-heading-alt><T id='newsMessages.social' defaultMessage='Social' description='as in social media' /></h1>
            <Card className={styles.socialCard}>
              <a target='_blank' href='https://www.facebook.com/ridewithgps'><img src={fb} /></a>
              <a target='_blank' href='https://www.instagram.com/ridewithgps'><img src={insta} /></a>
              <a target='_blank' href='https://www.twitter.com/ridewithgps'><img src={twit} /></a>
              <a target='_blank' href='https://www.youtube.com/ridewithgps'><img src={yt} /></a>
            </Card>
          </SecondaryCol>
        </ColWrap>
      </StandardLayout>
    )
  }
}

const NewsArticle = ({ a }) => {
  return <div className={styles.article}>
    <Link to={`/news/${a.slug}`} className={styles.articleTitle}>{a.title}</Link>
    <div className={styles.articleGrey}>{a.subtitle}</div>
    <div className={styles.articleGrey}>{moment(a.publishedAt).format('MMMM DD, YYYY')}</div>
  </div>
}

// https://stackoverflow.com/a/54947757
const getHostnameFromRegex = (url) => {
  // run against regex
  const matches = url.match(/^https?:\/\/([^/?#]+)(?:[/?#]|$)/i)
  // extract hostname (will be null if no match is found)
  return matches && matches[1]
}

const NewsLink = ({ a }) => {
  const prettyUrl = a.authorUrl && getHostnameFromRegex(a.authorUrl)
  return <div className={styles.article}>
    <a href={a.authorUrl} className={styles.articleTitle} target='_blank'>{a.title}</a>
    <div className={cx(styles.articleGrey, a.authorUrl && styles.articleUrl)}>
      <Icon i='md-open' /> Source: <a href={a.authorUrl} target='_blank'>{prettyUrl}</a>
    </div>
    <div className={styles.articleGrey}>{moment(a.publishedAt).format('MMMM DD, YYYY')}</div>
  </div>
}

const loadInitialData = ({ loadNews }) => {
  return Promise.all([loadNews()])
}

const LoadableNews = (props) => <Loadable
  {...props}
  component={_News}
  loadingText={<Msg m={newsMessages.loading} />}
  resourceLoaded={() => loadInitialData(props)} />

export const IntlNews = injectIntl(LoadableNews)

export const News = connect(
  state => ({ articles: rideReportSelectors.byUserId(state, NEWS_USERID) }),
  { loadNews: rideReportActions.news }
)(IntlNews)
